<template>
    <svg
        :class="className"
        :style="cssVars"
        xmlns="http://www.w3.org/2000/svg"
    >
        <title v-if="title">{{ title }}</title>
        <use :xlink:href="iconPath" xmlns:xlink="http://www.w3.org/1999/xlink"/>
    </svg>
</template>

<script>
    export default {
        name: 'SvgIcon',
        props: {
            name: {
                type: String,
                required: true
            },

            title: {
                type: String,
                default: null
            },

            isBlack: {
                type: Boolean,
                default: false
            },

            width: {
                type: Number,
                default: 15
            },

            height: {
                type: Number,
                default: 15
            }
        },

        computed: {
            iconPath() {
                // TODO: add default image to prevent errors
                let icon = require(`@/assets/img/icons/${this.name}.svg`);
                if (Object.prototype.hasOwnProperty.call(icon, 'default')) {
                    icon = icon.default;
                }

                return icon.url;
            },

            cssVars() {
                return {
                    '--height': `${this.height}px`,
                    '--width': `${this.width}px`
                }
            },

            className() {
                return `svg-icon svg-icon--${this.name} ${this.isBlack ? 'black-filter': ''}`;
            }
        }
    };
</script>

<style lang="scss" scoped>
    .svg-icon {
        height: var(--width);
        width: var(--height);
    }
    .black-filter {
        filter: brightness(0%);
    }
</style>